import { ITutorExperienceDetails } from '@wot/typings';
import { useAppDispatch, useAppSelector } from '../../../hooks/useRedux';
import { updateProfile } from '../../../reducers/profileSlice';
import ExperienceDetails from '../../ProfileSetup/containers/Experience/ExperienceDetails';
import { toast } from 'react-toastify';

export default function Experience() {
  const dispatch = useAppDispatch();
  const { profile } = useAppSelector((state) => state.profileSlice);

  const onSaveExperience = async (data: ITutorExperienceDetails) => {
    dispatch(updateProfile({ experience: data, status: 'under-review' })).then(() => {
      toast.success('Experience Details updated');
    });
  };

  return (
    <div className="relative max-w-5xl">
      <ExperienceDetails onSave={onSaveExperience} experience={profile?.experience} />
    </div>
  );
}
